import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const EmpresasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Empresas</PageTitle>
      <View />
    </>
  );
};

export { EmpresasPage };
